var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749268 10.9719C0.749268 15.8844 3.89927 20.0469 8.24927 21.5844V0.359375C3.89927 1.89688 0.749268 6.05938 0.749268 10.9719Z",
    fill: "#009A49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2495 10.9719C23.2495 6.05938 20.137 1.89688 15.7495 0.359375V21.5844C20.137 20.0469 23.2495 15.8844 23.2495 10.9719Z",
    fill: "#009A49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgnIcon);
export default __webpack_public_path__ + "static/media/ngn-icon.1dad0583ed35e84c0c137eddc8642d71.svg";
export { ForwardRef as ReactComponent };